<div class="dx-card-header__title">
  <div class="dx-card-header__title--hcc" >{{displayModelName}} {{icdGroup.hccId}}</div>
  <div class="dx-card-header__title--hccRangeGroup">
      <div class="dx-card-header__title--hccRangeGroup__hccRange"><span *ngIf="showGroupText; else showHccName">{{displayHeaderText}}</span></div>
  </div>
  <ng-template #showHccName> {{icdGroup.hccName}}</ng-template>
</div>